import { Component, inject } from '@angular/core';

import { IconComponent } from '@shared/components/icon/icon.component';
import { getModifierKey } from '@shared/utils/platform.util';

import { SearchModalService } from '../search-modal/services/search-modal.service';

@Component({
  imports: [IconComponent],
  selector: 'aux-search-section',
  template: `
    <div class="px-[14px]">
      <button
        (click)="openSearch()"
        class="flex w-full items-center gap-[8px] rounded-[4px] border border-[#C0C4CB] bg-white px-[8px] py-[5px] hover:bg-gray-50 focus:outline-none"
      >
        <aux-icon name="Search" [size]="20" class="text-aux-gray-dark-100" />
        <span class="flex-1 text-left text-[14px] font-normal leading-[20px] text-aux-gray-darkest">
          Search
        </span>
        <div
          class="flex items-center space-x-1 text-[14px] font-normal leading-[20px] text-[#868FA0]"
        >
          <kbd
            class="flex h-[16px] items-center justify-center rounded-[4px] bg-[#E9EDF5] px-[4px] text-[12px]"
          >
            {{ modifierKey }}
          </kbd>
          <kbd
            class="flex h-[16px] items-center justify-center rounded-[4px] bg-[#E9EDF5] px-[4px] text-[12px]"
          >
            K
          </kbd>
        </div>
      </button>
    </div>
  `,
})
export class SearchSectionComponent {
  searchModalService = inject(SearchModalService);

  modifierKey = getModifierKey();

  openSearch = () => {
    this.searchModalService.openSearchModal();
  };
}
